import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const shareVariantUsers = createApi('GetShareUserSlice', 'GET');

const GetShareUserSlice = createSlice({
  name: 'GetShareUserSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(shareVariantUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shareVariantUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(shareVariantUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetShareUserSlice.reducer;